import * as React from "react";
import { ThemeProvider } from "../stylingLib";
import { theme } from "./theme";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var NessieThemeProvider = function NessieThemeProvider(_ref) {
  var children = _ref.children;
  return _jsx(ThemeProvider, {
    theme: theme,
    children: children
  });
};
//# sourceMappingURL=NessieThemeProvider.js.map